<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='getUserTargetList_data.utTypeTwo' @change="TableChange" size='small'>
          <el-option :key="0" label="打卡" :value="1"></el-option>
          <el-option :key="1" label="金额" :value="2"></el-option>
          <el-option :key="2" label="单数" :value="3"></el-option>
          <el-option :key="3" label="业务数" :value="4"></el-option>
        </el-select>
        <el-button v-click.getUserTargetList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addUserTarget" @click=" $form('addUserTarget')" size='small' type="primary" style="float:right"
          icon='el-icon-circle-plus'>添加训战目标
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="mytable" :tree="{ children: 'children', lazy: lazyLoad }" :tableColums='tableColums_getUserTargetList'
      api='getUserTargetList::utId' updateapi='updateUserTarget' :height="H - 165" @expand="expand" @hasChildrenChange="hasChildrenChange">
      <div slot="utTargetJs" slot-scope='{row}'>{{ row.utTargetJs || 0 }}</div>
      <div slot="utTargetJe" slot-scope='{row}'>{{ row.utTargetJe || 0 }}</div>
      <div slot="utTargetSl" slot-scope='{row}'>{{ row.utTargetSl || 0 }}</div>
      <div slot="utTargetJeYear" slot-scope='{row}'>{{ row.utTargetJeYear || 0 }}</div>
      <div slot="utTargetVisitor" slot-scope='{row}'>{{ row.utTargetVisitor || 0 }}</div>
    </mytable>

    <myform :viewobj='{
        addUserTarget: ["新增训战目标信息", "el-icon-circle-plus"],
        updateUserTarget: ["修改训战目标信息", "el-icon-edit-outline"],
        $succeed$: getUserTargetList
      }' @close='$form("addUserTarget", "reset")'>
      <hide slot='utId' />
      <hide slot='projectId' />
      <template v-slot:utTypeTwo="{ Myformdata }">
        <el-select v-model='Myformdata.utTypeTwo' size='small'>
          <el-option :key="0" label="打卡" :value="1"></el-option>
          <el-option :key="1" label="金额" :value="2"></el-option>
          <el-option :key="2" label="单数" :value="3"></el-option>
          <el-option :key="3" label="业务数" :value="4"></el-option>
        </el-select>
      </template>
      <template v-slot:bcId="{ Myformdata }">
        <el-cascader ref='cascader2' v-model="Myformdata.bcId" clearable filterable size='small' placeholder='请选择分类'
          :show-all-levels='false' :options="getBusinessClassList_data ? getBusinessClassList_data.data : []"
          :props="props">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.bcName }}</span>
          </template>
        </el-cascader>
      </template>
    </myform>
    <myform view.addMultiUsersAll="批量训战目标" @opened='arguments[0].title += " | @" + "所有战队网格"'
      @close='$form("addMultiUsersAll", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
        <el-table-column prop="dtName" label="战队" width="120">
        </el-table-column>
        <el-table-column prop="utTargetJs" label="签约家数" width="120">
        </el-table-column>
        <el-table-column prop="utTargetJe" label="签约金额" width="120">
        </el-table-column>
        <el-table-column prop="utTargetSl" label="签约数量" width="80">
        </el-table-column>
        <el-table-column prop="utTargetJeYear" label="年化金额目标量" width="120">
        </el-table-column>
        <el-table-column prop="utTargetVisitor" fixed="left" label="走访目标" width="140">
        </el-table-column>
        <el-table-column prop="utCompleteJs" label="完成家数" width="100">
        </el-table-column>
        <el-table-column prop="utCompleteJe" label="完成金额" width="100">
        </el-table-column>
        <el-table-column prop="utCompleteSl" label="完成数量" width="100">
        </el-table-column>
        <el-table-column prop="targetVisitor" label="每日走访目标" width="100">
        </el-table-column>
        <el-table-column prop="targetMoney" label="每日开单金额目标" width="100">
        </el-table-column>
      </el-table>
    </myform>

  </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    let self = this
    return {
      props: {
        expandTrigger: 'click', checkStrictly: true, emitPath: false, label: 'bcName', value: 'bcId', children: 'children',
        lazy: true,
        lazyLoad(node, resolve) {
          console.log(node);
          const { level } = node;
          console.log(level);
          self.getBusinessClassListTwo({ bcParentId: node.data.bcId }).result(res => {
            if (res.data.data) {
              console.log(level)
              const nodes = res.data.data.map(item => ({
                bcId: item.bcId,
                bcName: item.bcName,
                leaf: level >= 2,
              }))
              resolve(nodes)
            }

          })
        }
      },
      tabledata: '',
      tabledataAll: '',
      tableColums_getUserTargetList: {
        $selection: false,

        utName: ['名称|align:left', 300],
        utTypeOne:['类型',100, '@v-if: 1:项目#warn, 2:战队#warn, 3:学员#warn'],
        bcName: '业务', 
        utTypeTwo:['维度类型',100, '@v-if: 1:打卡#warn, 2:金额#warn, 3:单数#warn ,4:业务数#warn'],
        utTarget: '目标', // (点击编辑)
        utTargetComplete: '完成量', 
        utTargetCompleteRate: '完成比(%)', // (点击编辑)
        utTimeComplete:'完成时间',
        // utTargetJe: '签约金额', // (点击编辑)
        // utTargetSl: '签约数量', // (点击编辑)
        // utTargetJeYear: '年化金额目标量', // (点击编辑)
        // utTargetVisitor: '走访目标', // (点击编辑)
        // utCompleteJs: '完成家数',
        // utCompleteJe: '完成金额',
        // utCompleteSl: '完成数量',
        // utCompleteJeYear: '完成年化金额目标量',
        // utCompleteVisitor: '完成走访目标',
      },

    };
  },

  watch: {

  },

  methods: {
    hasChildrenChange(value) {
        return value.hasChildren = true
    },
    async onChangeContent(files, fileList) {
      const table = await this.doupload(files.raw);
      this.tabledata = table.data.data.data;
      this.tabledataAll = table.data.data.data;
      this.getUserTargetList();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  //清空文件
      }
      if (this.$refs.uploadAll) {
        this.$refs.uploadAll.clearFiles();  //清空文件
      }
    },
    doupload: async function (file) {
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      if (this.row && this.row.projectId) {
        param.append("projectId", this.row.projectId);
      }
      console.log(param)
      const loading = $Loading();
      const responseData = await myhttp.postFileUsers("/opportunity/user-target/uploadUserTarget", param);
      loading.close();
      if (responseData.data.result == "success") {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
      } else {
        this.$message({
          type: "error",
          message: "上传失败!"
        });
      }
      return responseData
    },


    toDownExcel() {
      myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/dttarget.xlsx", "训战目标.xlsx");
    },
    TableChange(e) {
      this.getUserTargetList({ dtId: "", utTypeTwo: e });
      this.$forceUpdate()
    },
    lazyLoad(treeData, treeNode, resolve) {
      // console.error(treeData, treeNode, resolve);
      // this.$post('getUserTargetList', { dtId: treeData.dtId },' ');
      // console.error(treeData, treeNode);
      if (treeData.utTypeOne  ==  2) {

      };
      console.log(treeData);
      axios({
        method: 'post',
        baseURL: $Api.baseUrl_online, //线上
        url: (Apis.getUserTargetList || 0)[0] || '/opportunity/user-target/getUserTargetList',
        withCredentials: true,
        data: qs.stringify({ utId: treeData.utId}),
        timeout: 900000,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
          // "Set-Cookie": `httpOnly; Secure; SameSite = None`,
          // res.setHeader('Set-Cookie',`name={"loginname":"${userName}"}; httpOnly; Secure; SameSite = None`);
        }
      }).then(res => {
        let now;
        res = res.data.data || [];
        // console.error(res, treeData._rowIndex);
        if (res.length !== 0) return treeData.hasChildren2 = true, resolve(
          treeData.utTypeOne != 2
            ? forArr(res, v => (v.hasChildren = true, v._parent = treeData.utId))
            : forArr(res, v => (v._parent = treeData.utId, v.utName = v.utName), res = 1, now = Date.now())
        );
        treeData.hasChildren2 = false, resolve([]);
        /*setTimeout(() => {
          resolve([
            {
              dtId: 31,
              dtName: '王小虎',
              date: '2016-05-01',
              utTargetJs: '上海市普陀区金沙江路 1519 弄'
            }, {
              dtId: 32,
              dtName: '王小虎',
              date: '2016-05-01',
              utTargetJs: '上海市普陀区金沙江路 1519 弄'
            }
          ])
        }, 1000);*/
      }).catch(err => {
        resolve([]);
      });
      // console.error(res.data.data, resolve, treeNode);
    },

    /*onClick(event) {
        const tr = $(event.target).$parent('tr');
        if( tr.rowIndex > 0 ) {
            const row = tr.children[1].querySelector('.el-cell').row;
            row._rowIndex = tr.rowIndex + 1;
            // console.error( row, row.hasChildren2, tr.rowIndex + 1 );
        };
    },*/

    expand(row, expanded) {
      if (row.dtLevel == 1 || row.hasChildren2 === false) return;
      const treeData = this.$refs.mytable.Table.store.states.treeData, children = (treeData[row._parent] || 0).children || '';
      if (children.length < 2) return;
      // console.error(row, expanded, row._parent, children, row.hasChildren);
      for (let id of children) {
        if (id !== row.utId) treeData[id] && (treeData[id].expanded = false);
      };
      return;
    },

  },

  created() {
    this.getUserTargetList();
    this.getBusinessClassList({ bcParentId: 0 })
    this.getUserTargetList_data.ouBusinessId = 0;
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/User/UserTargerMine.vue